export default __webpack_public_path__ + "static/media/pin.85c57aac.svg";